import styled from 'styled-components';

export const ContentModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid #3232324d;
  gap: 10px;
  padding: 20px;
  box-sizing: border-box;
`;

export const DivActions = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 8px;
  box-sizing: border-box;
`;
